import { render, staticRenderFns } from "./ResourceAttribute.vue?vue&type=template&id=754e767c&scoped=true"
import script from "./ResourceAttribute.vue?vue&type=script&lang=js"
export * from "./ResourceAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e767c",
  null
  
)

export default component.exports